import {
  ServiceCategory,
  ServiceCategoryApi,
  ServiceCategoryFormData,
  ServiceCategoryFormDataApi,
  ServiceCategoryFormErrors,
  ServiceCategoryFormErrorsApi,
} from '../types/categories'

export class ServiceCategoryMappers {
  public static fromApi(categoryApi: ServiceCategoryApi): ServiceCategory {
    return {
      id: categoryApi.id,
      name: categoryApi.service_category_name,
      services:
        categoryApi.services?.map((service): ServiceCategory['services'][0] => ({
          id: service.service_id,
          name: service.service_name,
          price: parseFloat(service.service_price),
          isAppointment: !!service.accepted,
          doctors: service.doctors.map((doctor): ServiceCategory['services'][0]['doctors'][0] => ({
            id: doctor.doctor_id,
            name: doctor.doctor_name,
            price: parseFloat(doctor.price || '0'),
          })),
        })) || [],
      description: categoryApi.descr,
    }
  }

  public static manyFromApi(categoryApis: ServiceCategoryApi[]): ServiceCategory[] {
    return categoryApis.map((item) => this.fromApi(item))
  }

  public static formDataToApi(formData: ServiceCategoryFormData): ServiceCategoryFormDataApi {
    return {
      service_category_id: formData.id,
      service_category_name: formData.name,
      descr: formData.description,
    }
  }

  public static formErrorsFromApi(errors: ServiceCategoryFormErrorsApi): ServiceCategoryFormErrors {
    return {
      id: errors.service_category_id,
      name: errors.service_category_name,
      description: errors.descr,
      _custom: errors._custom,
    }
  }

  public static formInitializer(category: ServiceCategory): ServiceCategoryFormData {
    return {
      id: category.id.toString(),
      name: category.name,
      description: category.description || '',
    }
  }
}
